import { action, thunk, type Action, type Thunk } from 'easy-peasy';

import { getContacts as loadContacts } from 'apis/repositories/contactsRepository';
import type { FamilyContact } from 'types/domain';

interface ContactsState {
  contacts: FamilyContact[];
  loading: boolean;
  fetched: boolean;
  error: unknown | null;
}

export interface ContactsModel extends ContactsState {
  setDetails: Action<ContactsModel, Partial<ContactsState>>;
  getContacts: Thunk<ContactsModel>;
}

const defaultState: ContactsState = {
  contacts: [],
  loading: false,
  fetched: false,
  error: null,
};

const model: ContactsModel = {
  ...defaultState,

  setDetails: action((state, payload) => ({
    ...state,
    ...payload,
  })),

  getContacts: thunk(async (actions) => {
    actions.setDetails({ loading: true });

    try {
      const contacts = await loadContacts();
      actions.setDetails({ loading: false, fetched: true, contacts });
    } catch (error) {
      console.log('error - ', error);
      actions.setDetails({ loading: false, fetched: true, error, contacts: [] });
    }
  }),
};

export default model;
